import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  max-width: ${(props) => props.theme.misc.appWidth};
  margin: 0 auto;
  text-align: center;
  font-size: 12px;
  opacity: 0.2;
  color:#ffffff;
  text-transform: uppercase;
`;
const AppFooter = ({ version }) => <Container>{version}</Container>;
AppFooter.propTypes = {
  version: PropTypes.string.isRequired
};

export default AppFooter;
